module.exports = __webpack_public_path__ + "img/slam-dunk.11f43be4.svg";